import axios from 'axios'
import { APIURL, config } from './_utils'

export const cms = {
  getOne: (pageUrl, params = {}) =>
    axios.get(`${APIURL}/v2/cms/pages/page/${pageUrl}/`, config({ params })),
}
